import { Outlet } from 'react-router-dom';
// 网院智能体-----------------

import { Route, Routes } from 'react-router-dom';
import {
    AssistantLayout,
    EnaeaLayout,
    AiHeadTeacherLayout,
    AssistantNewLayout,
    NewAiHeadTeacherLayout,
    CommunistPartySecretaryLayout
} from '../layout';
import { Chats } from '../pages/enaea';
import { AssistantChats } from '../pages/assistant';
import { AiHeadTeacherChats } from '../pages/aiHeadTeacher';
import { AssistantNewChats } from '../pages/assistantNew';
import { NewAiHeadTeacherChats } from '../pages/newAiHeadTeacher';
import { CommunistPartySecretaryChats } from '../pages/communistPartySecretary';

// 移动端-----------------
import MobileLayout from '../pages/Mobile/index';
import MobileTools from '../pages/Mobile/Outside/pages/tools';
import MobileToolDetail from '../pages/Mobile/Outside/pages/tools/SourceDetailAI/index';
import MobileRecord from '../pages/Mobile/Outside/pages/tools/MobileRecord/index';
//外部
import MobileOutsideLayout from '../pages/Mobile/Outside';
import MobileOutsideHome from '../pages/Mobile/Outside/pages/home';
import MobileOutsideChats from '../pages/Mobile/Outside/pages/chat';
// 内部
import MobileInsideLayout from '../pages/Mobile/Inside';
import MobileInsideHome from '../pages/Mobile/Inside/pages/home';
import MobileInsideChats from '../pages/Mobile/Inside/pages/chat';

// web端-------
import WebLayout from '../pages/Web/index';
//外部
import WebOutsideLayout from '../pages/Web/Outside';
import WebOutsideHome from '../pages/Web/Outside/pages/home';
import WebOutsideChats from '../pages/Web/Outside/pages/chat';
import VideoPage from '../pages/Web/Outside/pages/video';
import Tools from '../pages/Web/Outside/pages/tools';
import ToolDetail from '../pages/Web/Outside/pages/tools/SourceDetailAI/index';
import Record, { EditRecord } from '../pages/Record';
import Test from '@/pages/Test';
import AiTest from '@/pages/Test/AiTest';
//案例仿真
import Simulation from '@/pages/Web/Outside/pages/Simulation';
import BackGround from '@/pages/Web/Outside/pages/Simulation/Pages/BackGround';
import Factor from '@/pages/Web/Outside/pages/Simulation/Pages/Factor';
import RoleIntroduce from '@/pages/Web/Outside/pages/Simulation/Pages/RoleIntroduce';

import Event from '@/pages/Web/Outside/pages/Simulation/Pages/Event';
import EventResult from '@/pages/Web/Outside/pages/Simulation/Pages/EventResult';
import ReviewReport from '@/pages/Web/Outside/pages/Simulation/Pages/ReviewReport';
//案例仿真移动端
import MobileSimulation from '@/pages/Mobile/Outside/pages/Simulation';
import MobileBackGround from '@/pages/Mobile/Outside/pages/Simulation/Pages/BackGround';
import MobileFactor from '@/pages/Mobile/Outside/pages/Simulation/Pages/Factor';
import MobileRoleIntroduce from '@/pages/Mobile/Outside/pages/Simulation/Pages/RoleIntroduce';

import MobileEvent from '@/pages/Mobile/Outside/pages/Simulation/Pages/Event';
import MobileEventResult from '@/pages/Mobile/Outside/pages/Simulation/Pages/EventResult';
import MobileReviewReport from '@/pages/Mobile/Outside/pages/Simulation/Pages/ReviewReport';
export const routes = (
    <Routes>
        {/* 网院智能体 */}
        <Route path={'/enaea'} element={<EnaeaLayout />}>
            <Route path={'chat'} element={<Chats />} />
            <Route path={'*'} element={<div>404</div>} />
        </Route>
        <Route path={'/assistant'} element={<AssistantLayout />}>
            <Route path={'chat'} element={<AssistantChats />} />
            <Route path={'*'} element={<div>404</div>} />
        </Route>
        <Route path={'/assistant_new'} element={<AssistantNewLayout />}>
            <Route path={'chat'} element={<AssistantNewChats />} />
            <Route path={'*'} element={<div>404</div>} />
        </Route>
        <Route path={'/aiHeadTeacher'} element={<AiHeadTeacherLayout />}>
            <Route path={'chat'} element={<AiHeadTeacherChats />} />
            <Route path={'*'} element={<div>404</div>} />
        </Route>
        <Route path={'/newAiHeadTeacher'} element={<NewAiHeadTeacherLayout />}>
            <Route path={'chat'} element={<NewAiHeadTeacherChats />} />
            <Route path={'*'} element={<div>404</div>} />
        </Route>
        <Route path={'/communist_party_secretary'} element={<CommunistPartySecretaryLayout />}>
            <Route path={'chat'} element={<CommunistPartySecretaryChats />} />
            <Route path={'*'} element={<div>404</div>} />
        </Route>
        {/* 移动端 */}
        <Route path={'/mobile'} element={<MobileLayout />}>
            <Route path="o" element={<MobileOutsideLayout />}>
                <Route path={'home'} element={<MobileOutsideHome />} />
                <Route path={':agentId'} element={<Outlet />}>
                    {/* 仿真 */}
                    <Route path={'simulation/:caseId/:sceneId'} element={<MobileSimulation />}>
                        <Route path={'background'} element={<MobileBackGround />} />
                        <Route path={'factor'} element={<MobileFactor />} />
                        <Route path={'role-introduce'} element={<MobileRoleIntroduce />} />

                        <Route path={'event'} element={<MobileEvent />} />
                        <Route path={'event-result'} element={<MobileEventResult />} />
                        <Route path={'review-report'} element={<MobileReviewReport />} />
                    </Route>
                    {/* 通用技能 */}
                    <Route path={'chat'} element={<MobileOutsideChats />} />
                    {/* 会话 */}
                    <Route path={'chat/:sessionId'} element={<MobileOutsideChats />} />
                    {/* 工具 */}
                    <Route path={':tools/:toolId'} element={<MobileOutsideChats />}>
                        <Route path={''} element={<MobileTools />} />
                        <Route path={':toolDetail'} element={<MobileToolDetail />} />
                        <Route path={'add/record'} element={<MobileRecord />} />
                    </Route>
                </Route>
            </Route>
            <Route path="i" element={<MobileInsideLayout />}>
                <Route path={'home'} element={<MobileInsideHome />} />
                <Route path={'chat/:agentId'} element={<MobileInsideChats />} />
            </Route>
            <Route path={'*'} element={<div>404</div>} />
        </Route>
        {/* web端 */}
        <Route path={'/web'} element={<WebLayout />}>
            <Route path="o" element={<WebOutsideLayout />}>
                <Route path={'test'} element={<Test />} />
                <Route path={'ai-test'} element={<AiTest />} />
                <Route path={'home'} element={<WebOutsideHome />} />
                {/* 视频播放页面 */}
                <Route path={'video/:videoId'} element={<VideoPage />} />
                <Route path={':agentId'} element={<Outlet />}>
                    {/* 仿真 */}
                    <Route path={'simulation/:caseId/:sceneId'} element={<Simulation />}>
                        <Route path={'background'} element={<BackGround />} />
                        <Route path={'factor'} element={<Factor />} />
                        <Route path={'role-introduce'} element={<RoleIntroduce />} />

                        <Route path={'event'} element={<Event />} />
                        <Route path={'event-result'} element={<EventResult />} />
                        <Route path={'review-report'} element={<ReviewReport />} />
                    </Route>

                    {/* 通用技能 */}
                    <Route path={'chat'} element={<WebOutsideChats />} />
                    {/* 会话 */}
                    <Route path={'chat/:sessionId'} element={<WebOutsideChats />} />
                    {/* 工具 */}
                    <Route path={':tools/:toolId'} element={<WebOutsideChats />}>
                        <Route path={''} element={<Tools />} />
                        <Route path={':toolDetail'} element={<ToolDetail />} />
                        <Route path={'add/record'} element={<Record />} />
                        <Route path={'record/edit/:taskId'} element={<EditRecord />} />
                    </Route>
                </Route>
                {/* <Route path={'chat/:agentId'} element={<WebOutsideChats />} /> */}
            </Route>
            <Route path="i" element={<MobileInsideLayout />}>
                <Route path={'home'} element={<MobileInsideHome />} />
                <Route path={'chat/:agentId'} element={<MobileInsideChats />} />
            </Route>
            <Route path={'*'} element={<div>404</div>} />
        </Route>
    </Routes>
);
